import { render } from "./TwoAxleTractorFourAxleSemitrailer.vue?vue&type=template&id=2baa23c8&scoped=true&ts=true"
import script from "./TwoAxleTractorFourAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./TwoAxleTractorFourAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./TwoAxleTractorFourAxleSemitrailer.vue?vue&type=style&index=0&id=2baa23c8&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baa23c8"]])

export default __exports__